import { Badge } from '@shadcn/ui/components/ui/badge';
import { useActions } from '../hooks/use-actions';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useQuery } from '@apollo/client';
import { GET_NUMBER_OF_URGENT_ACTIONS } from '@zaplify/graphql';

const LIMIT = 30;

export const ActionsCountBadge = () => {
    const { totalActionsCount } = useActions();
    const { actionsV2 } = useFlags();
    const { data: numberOfUrgentActions } = useQuery(GET_NUMBER_OF_URGENT_ACTIONS, { pollInterval: 20_000 });
    const numberOfUrgentActionsCount = numberOfUrgentActions?.urgentContacts?.aggregate?.count ?? 0;
    const numberOfActionsCount = actionsV2 ? numberOfUrgentActionsCount : totalActionsCount;
    return (
        <Badge variant="warning">
            {Math.min(numberOfActionsCount, LIMIT)} {numberOfActionsCount > LIMIT ? '+' : ''}
        </Badge>
    );
};

export const CompletedActionsCountBadge = () => {
    const { totalCompletedActions } = useActions();
    return (
        <Badge variant="outline">
            {Math.min(totalCompletedActions, LIMIT)} {totalCompletedActions > LIMIT ? '+' : ''}
        </Badge>
    );
};
